import { render, staticRenderFns } from "./wiki-comment.vue?vue&type=template&id=db350714"
import script from "./wiki-comment.vue?vue&type=script&lang=js"
export * from "./wiki-comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports